import { css } from '@mui/material/styles';
export const breadcrumbsComponentOverrides = {
    MuiBreadcrumbs: {
        styleOverrides: {
            root: ({ theme }) => css `
                font-size: ${theme.typography.button.fontSize};

                & .MuiBreadcrumbs-li .MuiTypography-root {
                   font-size: ${theme.typography.button.fontSize};
                }

                ${theme.breakpoints.down('sm')} {
                    line-height: ${theme.tokens.FuelSpacing6};
                    min-height: 29px;

                    & .MuiBreadcrumbs-li {
                        display: list-item;
                    }

                    & .MuiBreadcrumbs-li span {
                        display: flex;
                        align-items: center;
                    }

                    & li:not(:last-child) {
                        display: none;
                    }

                    & li:last-child {
                        background-image: url('data:image/svg+xml;utf-8,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24" width="24"><rect fill="none" height="24" width="24"/><path fill="${theme.tokens.FuelColorBrandPrimary}" d="M9,19l1.41-1.41L5.83,13H22V11H5.83l4.59-4.59L9,5l-7,7L9,19z"/></svg>`)}');
                        background-repeat: no-repeat;

                        & .MuiTypography-root {
                            margin-left: 1.75rem;
                            margin-top: 1px;
                        }
                    }
                }
            `
        }
    }
};
